import React, { useEffect, useState } from 'react';

import { Stack, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers-pro';

import { CommissionsConditionTypes, RuleCondition } from '~/consts/agentHub';

import { Dayjs, SYDNEY_TIMEZONE } from '~/services/TimeService';

import { formatSydneyDateOnly, parseSydneyDateOnly } from '~/utils/commissionDates';

interface Props {
  setCreatedConditions: (condition: RuleCondition, replace?: boolean) => void;
  conditionType: CommissionsConditionTypes;
  existingConditions: RuleCondition['value'];
  description?: string;
}

function AgentHubCommissionsDateRangeInput({
  setCreatedConditions,
  conditionType,
  existingConditions,
  description,
}: Props) {
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(null);

  useEffect(() => {
    if (existingConditions && existingConditions.length > 0) {
      try {
        const date = parseSydneyDateOnly(String(existingConditions[0].value));
        if (date.isValid()) {
          setSelectedDate(date);
        }
      } catch {
        // Keep the field empty if a stored value cannot be parsed.
      }
    }
  }, [existingConditions]);

  useEffect(() => {
    if (!selectedDate) {
      return;
    }

    const formattedDate = formatSydneyDateOnly(selectedDate);

    setCreatedConditions(
      {
        type: conditionType,
        value: [{ value: formattedDate, label: formattedDate }],
      },
      true,
    );
  }, [conditionType, selectedDate, setCreatedConditions]);

  return (
    <Stack gap={2}>
      <DatePicker
        label="Date"
        value={selectedDate}
        onChange={setSelectedDate}
        format="DD/MM/YYYY"
        timezone={SYDNEY_TIMEZONE}
        slotProps={{
          textField: {
            fullWidth: true,
            InputProps: { sx: { borderRadius: 0.5 } },
          },
        }}
      />

      <Typography variant="caption" color="textSecondary">
        Select a date and choose the comparison from the operator dropdown.
      </Typography>

      {description && (
        <Typography variant="caption" color="textSecondary">
          {description}
        </Typography>
      )}
    </Stack>
  );
}

export default AgentHubCommissionsDateRangeInput;
